import { render } from "./OrganizationSettings.vue?vue&type=template&id=183d90e8"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__